// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "vendors-node_modules_hashgraph_hashconnect_dist_esm_main_js-node_modules_hashgraph_hedera-wal-4ff76a") return "static/js/" + chunkId + ".bundle.js";
	if (chunkId === "main") return "static/js/main.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + ".chunk.js";
};